import { toggleModal } from '../../../Store/layoutSlice';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { useDeleteFileMutation } from '../../../Store/file';
import { currentFileIdSelector } from '../../../Store/paramsBagSlice';

export const useFileDeleteForm = () => {
  const dispatch = useAppDispatch();

  const currentFileId = useAppSelector(currentFileIdSelector);
  const [deleteFile, { isLoading }] = useDeleteFileMutation();
  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      await deleteFile({ id: currentFileId });
    } catch (e) {
    } finally {
      dispatch(toggleModal());
    }
  };

  return { onSubmit, isLoading };
};
